import { atom, useSetAtom } from 'jotai';

export const navbarAtom = atom<{
  type: 'primary' | 'secondary' | 'none' | 'search';
  place: string;
  title: string;
  subtitle?: string;
  isBack?: boolean;
}>({
  type: 'primary',
  place: 'Алматы',
  title: 'Главная страница',
  isBack: false,
});

export function useNavbar() {
  const setData = useSetAtom(navbarAtom);

  return {
    none() {
      setData((store) => {
        return { type: 'none', title: '', place: store.place };
      });
    },
    search() {
      setData((store) => {
        return { type: 'search', title: '', place: store.place };
      });
    },
    notifications() {
      setData((store) => {
        return {
          type: 'secondary',
          title: 'Уведомления',
          place: store.place,
          isBack: true,
        };
      });
    },
    orders() {
      setData((store) => {
        return {
          type: 'secondary',
          title: 'История заказов',
          place: store.place,
          isBack: true,
        };
      });
    },
    cart() {
      setData((store) => {
        return { type: 'secondary', title: 'Корзина', place: store.place };
      });
    },
    initial() {
      setData((store) => {
        return {
          type: 'secondary',
          title: 'Выберите город',
          place: store.place,
        };
      });
    },
    about() {
      setData((store) => {
        return {
          type: 'secondary',
          title: 'О приложении',
          place: store.place,
          isBack: true,
        };
      });
    },
    privacy() {
      setData((store) => {
        return {
          type: 'secondary',
          title: 'Политика конфиденциальности',
          place: store.place,
          isBack: true,
        };
      });
    },
    terms() {
      setData((store) => {
        return {
          type: 'secondary',
          title: 'Правила польования',
          place: store.place,
          isBack: true,
        };
      });
    },
    profile() {
      setData((store) => {
        return { type: 'secondary', title: 'Профиль', place: store.place };
      });
    },
    popupar() {
      setData((store) => {
        return {
          type: 'secondary',
          title: 'Популярные товары',
          place: store.place,
          isBack: true,
        };
      });
    },
    editProfile() {
      setData((store) => {
        return {
          type: 'secondary',
          title: 'Данные профиля',
          place: store.place,
          isBack: true,
        };
      });
    },
    location() {
      setData((store) => {
        return {
          type: 'secondary',
          title: 'Выберите город',
          place: store.place,
          isBack: true,
        };
      });
    },
    contacts() {
      setData((store) => {
        return {
          type: 'secondary',
          title: 'Служба поддержки',
          place: store.place,
          isBack: true,
        };
      });
    },
    checkout() {
      setData((store) => {
        return {
          type: 'secondary',
          title: 'Оформление заказа',
          place: store.place,
          isBack: true,
        };
      });
    },
    pharmacy() {
      setData((store) => {
        return {
          type: 'secondary',
          title: 'Пункт самовывоза',
          place: store.place,
          isBack: true,
        };
      });
    },
    availability() {
      setData((store) => {
        return {
          type: 'secondary',
          title: 'Подробнее',
          place: store.place,
          isBack: true,
        };
      });
    },
    subcategory(title: string, subtitle: string) {
      setData((store) => {
        return {
          type: 'secondary',
          subtitle,
          title,
          place: store.place,
          isBack: true,
        };
      });
    },
    productFilters() {
      setData((store) => {
        return {
          type: 'secondary',
          title: 'Фильтры',
          place: store.place,
          isBack: true,
        };
      });
    },
    category(title: string) {
      setData((store) => {
        return { type: 'secondary', title, place: store.place, isBack: true };
      });
    },
    categories() {
      setData((store) => {
        return { type: 'secondary', title: 'Каталог', place: store.place };
      });
    },
    favorite() {
      setData((store) => {
        return {
          type: 'secondary',
          title: 'Избранное',
          place: store.place,
          isBack: true,
        };
      });
    },
    store() {
      setData((store) => {
        return { type: 'secondary', title: 'Аптеки', place: store.place };
      });
    },
    main() {
      setData((store) => {
        return { type: 'primary', title: 'Главная', place: store.place };
      });
    },
  };
}
